import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=28c57d66&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=ts"
export * from "./AddressItem.vue?vue&type=script&lang=ts"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=28c57d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c57d66",
  null
  
)

export default component.exports